import { render, staticRenderFns } from "./FamousCommentItemWeb.vue?vue&type=template&id=7435bbad&"
import script from "./FamousCommentItemWeb.vue?vue&type=script&lang=js&"
export * from "./FamousCommentItemWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports